import { MouseEventHandler, useRef, useState } from "react";
import { FaSave } from "react-icons/fa";
import { IoIosAddCircleOutline, IoIosTrash } from "react-icons/io";
import { IoDuplicateOutline } from "react-icons/io5";
import { RxReset } from "react-icons/rx";
import { SlCalculator } from "react-icons/sl";

import { LONG_TERM_PROMOTION_SUB_TAB_ID, PROMOTION_PLANNING_TAB_ID, SHORT_TERM_PROMOTION_SUB_TAB_ID, VOLUME_FORECAST_TAB_ID } from "../../../shared/constants";
import { createPortal } from "react-dom";
import Modal from "../Modal/Modal";
import ChangeLogForm from "../ChangeLog/ChangeLogForm";

const EditableGridActions = (props: {
  tabId: string,
  disableIf: {
    resetBtn: boolean;
    reCalculateBtn?: boolean;
    saveBtn: boolean;
    deleteRowBtn?: boolean;
    duplicateRowBtn?: boolean;
  },
  onClick: {
    resetBtn: MouseEventHandler<HTMLButtonElement>;
    reCalculateBtn?: MouseEventHandler<HTMLButtonElement>;
    saveBtn?: any;
    addRowBtn?: MouseEventHandler<HTMLButtonElement>;
    deleteRowBtn?: any;
    duplicateRowBtn?: MouseEventHandler<HTMLButtonElement>;
  },
  hideButtons?: {
    reCalculateBtn?: boolean;
    addRowBtn?: boolean;
    deleteRowBtn?: boolean;
  }
}) => {
  const changeLogModalCloseRef = useRef<HTMLButtonElement>(null);
  const changeLogModalID: string = `changeLogModal${props.tabId}`;
  const [event, setEvent] = useState<any>()

  return (
    <div className="d-flex justify-content-end align-items-center">

      {
        (
          props.tabId === SHORT_TERM_PROMOTION_SUB_TAB_ID ||
          props.tabId === LONG_TERM_PROMOTION_SUB_TAB_ID
        ) && (
          <button
            className="btn btn-sm border border-dark-subtle mx-1 text-white"
            title="Duplicate Row"
            style={{ backgroundColor: "#00833E" }}
            onClick={props.onClick.duplicateRowBtn}
            disabled={props.disableIf.duplicateRowBtn}
          >
            <div className="d-flex justify-content-center align-items-center">
              <IoDuplicateOutline size={20} /> &nbsp;Duplicate Row
            </div>
          </button>)
      }


      <div className="btn-group btn-group-sm me-1" role="group">
        {(
          [
            VOLUME_FORECAST_TAB_ID, 
            PROMOTION_PLANNING_TAB_ID,
            LONG_TERM_PROMOTION_SUB_TAB_ID, 
            SHORT_TERM_PROMOTION_SUB_TAB_ID
          ].includes(props.tabId) && 
          !props.hideButtons?.reCalculateBtn
        ) && (
            <button
              className="btn btn-warning border border-dark-subtle"
              title="Re-calculate values"
              onClick={props.onClick.reCalculateBtn}
              disabled={props.disableIf.reCalculateBtn}
            >
              <SlCalculator size={20} />
            </button>
          )}

        <button
          className="btn btn-danger border border-dark-subtle"
          title="Reset changes"
          onClick={props.onClick.resetBtn}
          disabled={props.disableIf.resetBtn}
        >
          <RxReset size={20} />
        </button>

        <button
          className="btn btn-success border border-dark-subtle"
          title="Save changes"
          onClick={()=>{
            setEvent((prev:any)=>props.onClick.saveBtn);
          }}
          data-bs-toggle="modal" data-bs-target={`#${changeLogModalID}`}
          disabled={props.disableIf.saveBtn}
        >
          <FaSave size={20} />
        </button>
      </div>

      {!props.hideButtons?.addRowBtn && (
        <button
          className="btn btn-sm text-white me-1"
          style={{ backgroundColor: "#00833E" }}
          title="Add a row"
          onClick={props.onClick.addRowBtn}
        >
          <div className="d-flex justify-content-center align-items-center">
            <IoIosAddCircleOutline size={20} /> &nbsp;Add Row
          </div>
        </button>
      )}

      {!props.hideButtons?.deleteRowBtn && (
        <button
          className="btn btn-sm btn-danger text-white me-1"
          title="Delete selected row(s)"
          disabled={props.disableIf.deleteRowBtn}
          onClick={()=>{
            setEvent((prev:any)=>props.onClick.deleteRowBtn);
          }}
          data-bs-toggle="modal" data-bs-target={`#${changeLogModalID}`}
        >
          <div className="d-flex justify-content-center align-items-center">
            <IoIosTrash size={20} /> &nbsp;Delete Row
          </div>
        </button>
      )}

      {
          createPortal(
              <Modal
                  id={changeLogModalID}
                  ref={changeLogModalCloseRef}
                  title={"Change Log"}
                  onModalClose={() => { }}
              >
                  <ChangeLogForm modalRef={changeLogModalCloseRef} 
                    saveEvent={async (e: MouseEventHandler<HTMLButtonElement>, data:any) => { 
                      await event(e, data); }} 
                    tabName={props.tabId} />
              </Modal>,
              document.getElementById("modal-root") as HTMLElement
          )
      }
    </div>
  );
};

export default EditableGridActions;
